import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const getReportState = createFeatureSelector<State>('reportType');

export const getReportTypes = createSelector(
  getReportState,
  (state: State) => state.reports
);

export const getVersions = createSelector(
  getReportState,
  (state: State) => state.versions
);


export const getReportsProgress = createSelector(
  getReportState,
  (state: State) => state.progress
);
